import React, { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Check } from "lucide-react";

const NewsletterSignup = ({ source = "home_footer" }) => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitting(true);
    try {
      await api.post("/subscribers", { email: email.trim(), source });
      setDone(true);
      setEmail("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not subscribe. Try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section
      className="px-6 md:px-12 lg:px-20 py-20 md:py-28 border-t border-[#D8D3CC] bg-[#F7F6F2]"
      data-testid="newsletter-section"
    >
      <div className="max-w-3xl mx-auto text-center">
        <div className="label-eyebrow mb-5">Studio Notes</div>
        <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-[#1A1F1B] leading-[1.05]">
          Stay close to the studio.
        </h2>
        <p className="mt-6 text-base md:text-lg text-[#4E5C50] leading-relaxed max-w-xl mx-auto">
          New work, upcoming shows, and early access to original pieces before
          they reach the shop.
        </p>

        {done ? (
          <div
            className="mt-10 inline-flex items-center gap-3 text-[#3B4A3F]"
            data-testid="newsletter-success"
          >
            <Check size={18} strokeWidth={1.5} />
            <span className="text-sm uppercase tracking-[0.22em]">
              You&apos;re on the list — thank you.
            </span>
          </div>
        ) : (
          <form
            onSubmit={submit}
            className="mt-10 flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
            data-testid="newsletter-form"
          >
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              className="flex-1 bg-transparent border border-[#D8D3CC] focus:border-[#3B4A3F] outline-none px-5 py-4 text-base text-[#1A1F1B] placeholder:text-[#849383] transition-colors"
              data-testid="newsletter-input-email"
            />
            <button
              type="submit"
              disabled={submitting}
              className="inline-flex items-center justify-center bg-[#3B4A3F] hover:bg-[#2C382F] text-[#F7F6F2] border border-[#3B4A3F] px-8 py-4 text-sm uppercase tracking-[0.22em] font-medium transition-colors disabled:opacity-50"
              data-testid="newsletter-submit"
            >
              {submitting ? "Subscribing…" : "Subscribe"}
            </button>
          </form>
        )}
        <p className="mt-5 text-xs text-[#849383]">
          No spam, ever. Unsubscribe anytime.
        </p>
      </div>
    </section>
  );
};

export default NewsletterSignup;
